import { render, staticRenderFns } from "./AssessmentRecordDetail.vue?vue&type=template&id=343ad838"
import script from "./AssessmentRecordDetail.vue?vue&type=script&lang=js"
export * from "./AssessmentRecordDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports